import React from 'react';
import PrateekTiwari from '../../img/PrateekTiwari.png';
import ShivaniGarg from '../../img/ShivaniGarg.png';

const LeadershipGroup = () => {
    return (
        <div className='px-4 md:px-12 my-20'>
            <h1 className='md:text-5xl text-3xl font-semibold text-center'>Discover Our <span className='text-blue-400'>Leadership</span> Group</h1>
            <h4 className='text-center my-5 md:px-28'>When it comes to developing the future of the counselling platform or choosing the destination for the vacation, Career Hikers has some of the brightest minds.</h4>
            <h1 className='md:text-5xl text-2xl font-semibold text-center'>The Founding <span className='text-orange-400'>Team</span></h1>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 mt-4 md:mt-8'>
                <div className='mx-auto'>
                    <img className='rounded-full w-52' src={PrateekTiwari} alt="" />
                    <h4 className='text-center text-xl font-semibold'>Prateek Tiwari</h4>
                    <p className='text-center text-sm mb-1'>CEO and Founder</p>
                </div>
                <div className='mx-auto'>
                    <img className='rounded-full w-52' src={ShivaniGarg} alt="" />
                    <h4 className='text-center text-xl font-semibold'>Shivani Garg</h4>
                    <p className='text-center text-sm mb-1'>CEO and Co-founder</p>
                </div>
            </div>
        </div>
    );
};

export default LeadershipGroup;